// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.use(VueFriendlyIframe);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyChT5wyyCtbr7v_9aP_KCgh5kr5lw0_EBc'
  }
})
Vue.use(Vuetify)

Vue.config.productionTip = false

/*import VeeValidate from 'vee-validate'
const config = {
    errorBagName: '_errors', // change if property conflicts.
}
Vue.use(VeeValidate, config);*/

//var baseURL = 'https://api.agendaenlinea.cl/api'
let baseURL;
import { env } from './config/env.js'
if (!process.env.NODE_ENV) process.env.NODE_ENV = JSON.parse(config.dev.env.NODE_ENV)
/*
if (process.env.NODE_ENV == 'development') {
  baseURL = env.baseURL;
  urlGlobal = env.urlGlobal
}
*/

/** AGREGADO POR MAURICIO MARCHANT PARA ESTABLECER 3 AMBIENTES, LOCAL-DESARROLLO Y PRODUCCIÓN INDEPENDIENTE SI LA APP ESTÁ EN MODO PRODUCTION O DELVELOPMENT*/
switch(env.enviroment){
  default: 
      baseURL = env.baseURL;
  break;
  case 'local':
      baseURL = env.LOCALbaseURL;
  break;
  case 'development':
      baseURL = env.DEVbaseURL;
  break;
}



import axios from 'axios'
import VueAxios from 'vue-axios'
var instance_axios = axios.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})
Vue.use(VueAxios, instance_axios)

import store from './store'

import Lang from './packages/lang/Lang.js'
Vue.use(Lang)

import fullName from './filters/fullName.js'
Vue.filter('fullName', fullName)

// Define constant urlGlobal
Vue.mixin({
  data: function() {
    return {
      get baseURL(){
        return baseURL
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App}
})



// WEBPACK FOOTER //
// ./src/main.js